export default __webpack_public_path__ + "static/media/latest1.4ffa9f07.jpg";